<template>
    <b-modal :active.sync="modalActive" :width="640" scroll="keep" @close="toggleModal">
        <div class="card">
            <header class="modal-card-head">
                <p class="modal-card-title">Gebruiker {{ mode === 'new' ? 'toevoegen' : 'aanpassen' }}</p>
            </header>
            <div class="card-content">
                <div class="content">
                    <div class="row" v-if="user && (user.role === 'pit' || mode === 'new' && user.is_admin) && (organisations && (organisations.length > 1 || Object.keys(organisations).length > 1)) && from === 'AccountsOverview'">
                        <div class="column">
                            <b-field label="Organisatie"
                                :message="getError(errors, 'organisation')"
                                :type="getType(errors, 'organisation', '')"
                            >
                                <span>
                                    <b-select placeholder="Selecteer een organisatie" v-model="record.organisation" expanded>
                                        <option
                                            v-for="organisation in organisations"
                                            :value="organisation.organisation || organisation.id"
                                            :key="'organisatie_'+organisation.id"
                                        >{{ organisation.name }}</option>
                                    </b-select>
                                </span>
                            </b-field>
                        </div>
                    </div>

                    <b-field label="Naam" :message="getError(errors, 'name')" :type="getType(errors, 'name', '')">
                        <b-input v-model="record.name" placeholder="Voornaam" :disabled="loading"></b-input>
                    </b-field>
                    <b-field label="E-mailadres" :message="getError(errors, 'email')" :type="getType(errors, 'email', '')">
                        <b-input type="email"
                                 v-model="record.email"
                                 placeholder="email@adres.nl"
                                 :disabled="loading || mode == 'edit'"
                                 icon-right="copy"
                                 icon-right-clickable
                                 @icon-right-click="copyText(record.email)" />
                    </b-field>
                    <b-field label="Rol" :message="getError(errors, 'role')" :type="getType(errors, 'role', '')">
                        <b-select placeholder="Selecteer een rol" v-model="record.role" :disabled="loading" expanded>
                            <option value="owner" :disabled="user.role !== 'pit' && !isOwner">Eigenaar</option>
                            <option value="user">Gebruiker</option>
                            <option value="admin">Administrator</option>
                            <option value="deurwaarder">Deurwaarder</option>
                        </b-select>
                    </b-field>
                    <b-notification type="is-warning" v-show="record.role == 'owner'" aria-close-label="Close notification" role="alert">
                        Let op: Er kan maar 1 eigenaar zijn per organisatie.
                    </b-notification>
                </div>
            </div>
            <footer class="modal-card-foot">
                <b-button type="is-light" @click="toggleModal" :disabled="loading">Annuleren</b-button>
                <b-button type="is-success" @click="newOrEdit" :loading="loading">{{ confirmText }}</b-button>
            </footer>
        </div>
    </b-modal>
</template>

<script>
import formvalidationMixin from '@/mixins/formvalidationMixin.js'
import toastMixin from '@/mixins/toastMixins.js'

const baseRecord = {
    name: '',
    email: '',
    role: 'user',
    organisation: null
}

export default {
    name: 'UserCRUDModal',

    mixins: [formvalidationMixin, toastMixin],

    props: {
        from: {
            type: String,
            required: true
        }
    },

    data () {
        return {
            modalActive: false,
            record: {...baseRecord},
            errors: {},
            loading: false,
            mode: 'new',
            preferredOrganisation: null
        }
    },

    computed: {
        user () {
            return this.$store.state.user
        },

        organisations() {
            // Show all organisations if user is a pit user, else only where you are an admin or owner.
            return this.user.role === 'pit' ? this.$store.state.organisations : (Object.values(this.user?.organisations) || []).filter((x) => ['admin', 'owner'].indexOf(x.role) !== -1)
        },

        confirmText() {
            if (this.mode == 'new') {
                return 'Toevoegen'
            } else {
                if (this.user.role === 'pit' && !_.isNull(this.preferredOrganisation) && this.preferredOrganisation !== this.record.organisation) {
                    return 'Toevoegen'
                }

                return 'Aanpassen'
            }
        },

        isOwner() {
            return this.user.role === 'pit' || (this.user?.organisations[this.record?.organisation] && this.user?.organisations[this.record?.organisation]?.role === 'owner')
        }
    },

    methods: {
        toggleModal (mode, preferredOrganisation, user) {
            this.mode = mode || 'new'
            this.modalActive = !this.modalActive

            // If there is only one organisation, set it as default.
            if (this.organisations && Object.keys(this.organisations).length === 1) {
                this.record.organisation = this.organisations[0].organisation
            } else if (preferredOrganisation) {
                this.record.organisation = preferredOrganisation
                this.preferredOrganisation = preferredOrganisation
            }

            if (user) {
                this.record.id = user.id
                this.record.name = user.name
                this.record.email = user.email
                this.record.role = user.user_organisation.role
            }

            // Reset
            if (!this.modalActive) this.reset()
        },

        newOrEdit () {
            this.loading = true
            let result
            let newOrEdit

            if (this.mode === 'new') {
                newOrEdit = 'new'
                result = axios.post('/api/users/create', this.record, { headers: {'Authorization': 'bearer ' + this.$store.state.authToken} })
            } else {
                newOrEdit = 'edit'
                result = axios.put(`/api/users/${this.record.id}`, this.record, { headers: {'Authorization': 'bearer ' + this.$store.state.authToken} })
            }

            result.then(() => {
                this.toggleModal()
                this.$emit('refresh')

                if (newOrEdit === 'new') {
                    this.showMessage('Gebruiker toegevoegd!')
                } else {
                    this.showMessage('Gebruiker aangepast!')
                }
            }).catch((error) => {
                if (error.response.data.errors) {
                    this.errors = {...error.response.data.errors}
                } else {
                    if (error.response.data.error === 'not-authorized') {
                        this.showError('Je hebt geen rechten om deze actie uit te voeren.')
                    } else {
                        this.showError(error.response.data.error)
                    }
                }
            }).then(() => {
                this.loading = false
            })
        },

        promptDelete (user, organisation) {
            this.$buefy.dialog.confirm({
                title: 'Verwijderen',
                message: 'Weet je zeker dat je deze gebruiker wilt verwijderen?',
                confirmText: 'Ja, verwijderen',
                cancelText: 'Annuleren',
                type: 'is-danger',
                hasIcon: true,
                onConfirm: () => {
                    this.deleteUser(user, organisation)
                }
            })
        },

        deleteUser (user, organisation) {
            this.loading = true

            axios.delete(`/api/users/${user}/${organisation}`, { headers: {'Authorization': 'bearer ' + this.$store.state.authToken} }).then(() => {
                this.$emit('refresh')
                this.showMessage('Gebruiker verwijderd!')
            }).catch((error) => {
                this.showError(error.response.data.error)
            }).then(() => {
                this.loading = false
            })
        },

        reset () {
            this.record = {...baseRecord}
            this.errors = {}
            this.preferredOrganisation = null
            this.loading = false
        },

        async copyText (text) {
            try {
                const textArea = document.createElement('textarea')
                textArea.value = text
                document.body.appendChild(textArea)
                textArea.select()
                document.execCommand('copy')
                document.body.removeChild(textArea)
                this.showMessage('E-mailadres gekopieerd!')
            } catch (err) {
                this.showError('E-mailadres niet gekopieerd!')
            }
        }
    }

}
</script>